export default class IconGrid {
    /**
     * @var {boolean}
     */
    visible = false;
}

document.addEventListener("alpine:init", () => {
    Alpine.data("iconGrid", () => new IconGrid());
});
